import React, { useState } from "react";
import { CategoriesIcon } from "../../../assets/img/CategoriesIcon";
import { CollectionDefaultValue } from "../../../defalult/CollectionDefaultValue";
import {
  CategoriesFilterValue,
  FilterWrapper,
  MarketplaceFilterButton,
  MarketplaceFilterCol,
  MarketplaceFilterDropdownCategories,
  MarketplaceFilterDropdownCollection,
  MarketplaceFilterDropdownSort,
  MarketplaceFilterSearch,
} from "./MarketplaceFilter.styled";

const sorts = [
  "Nаme (A-Z)",
  "Nаme (Z-A)",
  "Price: High to Low",
  "Price: Low to High",
  "Rаrity: Rаre to Common",
  "Rаrity: Common to Rаre",
  "Mint dаte: New to Old",
  "Mint dаte: Old to New",
];

export const SortFilter = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [active, setActive] = useState("Nаme (A-Z)");
  return (
    <FilterWrapper
      onMouseLeave={() => {
        setShowDropdown(false);
      }}>
      <MarketplaceFilterButton
        onMouseEnter={() => {
          setShowDropdown(true);
        }}>
        {active}
      </MarketplaceFilterButton>
      <MarketplaceFilterDropdownSort showDropdown={showDropdown}>
        {sorts.map((sort, i) => (
          <CategoriesFilterValue
            active={sort === active && true}
            onClick={() => {
              setActive(sort);
            }}
            key={i}>
            {sort}
          </CategoriesFilterValue>
        ))}
      </MarketplaceFilterDropdownSort>
    </FilterWrapper>
  );
};
